const { connect } = require('react-redux');
const { context } = require('../app-context');
const DowntimeDialog = require('components/DowntimeDialog');
const Connectivity = require('initializers/connectivity');

const selectors = context.selectors.all;
const api = context.api.nearpeer;

module.exports = connect(
    (state) => ({
        isDowntimeMode: selectors.getIsDowntimeMode(state),
        downtimeMessage: selectors.getDowntimeMessage(state),
        downtimeType: selectors.getDowntimeType(state)
    }), {
        checkIsDowntimeMode: () => () => { // eslint-disable-line

            api.ping();
        },
        retryPendingRequest: () => () => Connectivity.retryPendingRequest(),
        continueWithoutRetry: () => () => Connectivity.continueWithoutRetry()
    }
)(DowntimeDialog);
